
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsSalesmanDialog extends Serenity.EntityDialog<PsSalesmanRow, any> {
        protected getFormKey() { return PsSalesmanForm.formKey; }
        protected getIdProperty() { return PsSalesmanRow.idProperty; }
        protected getLocalTextPrefix() { return PsSalesmanRow.localTextPrefix; }
        protected getNameProperty() { return PsSalesmanRow.nameProperty; }
        protected getService() { return PsSalesmanService.baseUrl; }
        protected getDeletePermission() { return PsSalesmanRow.deletePermission; }
        protected getInsertPermission() { return PsSalesmanRow.insertPermission; }
        protected getUpdatePermission() { return PsSalesmanRow.updatePermission; }

        protected form = new PsSalesmanForm(this.idPrefix);
        protected afterLoadEntity() {
            super.afterLoadEntity();

            var CashierId = Q.tryFirst(Customer.CsCustomerRow.getLookup().items, x => x.SalesmanId == this.entity.SalesmanId);
            if (CashierId != null) {
                this.deleteButton.toggleClass('disabled', true);

            }
            var report = Q.tryFirst(PosShift.PosTranHdRow.getLookup().items, x => x.SalesmanId == this.entity.SalesmanId);
            if (report != null) {
                this.deleteButton.toggleClass('disabled', true);

            }
        }
    }
}